import React, { useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { NotificationShape } from '../../propTypes';
import { RealTimeNotificationsStats } from '../../stats';
import { ListItem } from '../../../../../../shared/components/ListItem';
import { SafeComponent } from '../../../../../../shared/SafeComponent';
import { REALTIME_NOTIFICATION_LOG_MODULE } from '../../../../../shared/constants';
import { eventTypes } from '../../stats/eventTypes';
import { LAYOUT_SOURCES } from '../../../../../../shared/types/layoutSources';
import classes from './index.module.scss';
import { useAnimationState, ANIMATION_DURATION, ANIMATION_STATE } from './useAnimationState';

export function NotificationToastComponent(props) {
    const { notification, onExpiration, duration } = props;
    const { animationState, startAnimating } = useAnimationState({
        startAfter: duration - ANIMATION_DURATION,
    });

    const isExpired = animationState === ANIMATION_STATE.STARTED || animationState === ANIMATION_STATE.COMPLETED;

    const className = classNames(classes.card, { [classes.expired]: isExpired });

    const onDismiss = (e) => {
        e.stopPropagation();
        startAnimating();
        trackDismiss();
    };

    useEffect(() => {
        if (animationState === ANIMATION_STATE.COMPLETED) {
            onExpiration();
        }
    }, [animationState, onExpiration]);

    return (
        <ListItem
            item={notification}
            className={className}
            onClick={trackClick}
            dismissable={true}
            layoutSource={LAYOUT_SOURCES.TOAST}
            onDismiss={onDismiss}
        />
    );
}

function trackClick() {
    RealTimeNotificationsStats.count(eventTypes.NOTIFICATION_TOAST_CLICKED);
}

function trackDismiss() {
    RealTimeNotificationsStats.count(eventTypes.NOTIFICATION_TOAST_DISMISSED);
}

NotificationToastComponent.propTypes = {
    notification: NotificationShape.isRequired,
    onExpiration: PropTypes.func.isRequired,
    duration: PropTypes.number.isRequired,
};

export const NotificationToast = SafeComponent(
    REALTIME_NOTIFICATION_LOG_MODULE,
    'NotificationToast'
)(NotificationToastComponent);
